import { addAuthorizationToHeaders } from "./CommonService"
import refreshClient, { handleErrors } from "./api/RefreshClient"

export async function addNewComment(newCommentRequest) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return refreshClient.post("comments", newCommentRequest, {headers})
            .then(data => data)
            .catch(error => handleErrors(error)
                            .then(data => data)
                            .catch(err => Promise.reject(err))
            )
    })
}

export async function getArticleComments(articleId) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return refreshClient.get("comments/articleId/" + articleId, {headers})
            .then(data => data.data)
            .catch(error => handleErrors(error)
                    .then(data => data)
                    .catch(err => Promise.reject(err))    
            )             
    })
}

export async function likeComment(commentId) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return refreshClient.put("comments/likes/" + commentId, {}, {headers})
            .then(data => data.data)
            .catch(error => handleErrors(error)
                            .then(data => data)
                            .catch(err => Promise.reject(err))    
            )
    })
}

export async function dislikeComment(commentId) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return refreshClient.put("comments/dislikes/" + commentId, {}, {headers})
            .then(data => data.data)
            .catch(error => handleErrors(error)
                            .then(data => data)
                            .catch(err => Promise.reject(err))    
            )
    })
}

export async function removeLiking(commentId) {
    return addAuthorizationToHeaders({})
    .then(async headers => {
        return refreshClient.put("comments/unlikes/" + commentId, {}, {headers})
            .then(data => data.data)
            .catch(error => handleErrors(error)
                            .then(data => data)
                            .catch(err => Promise.reject(err))    
            )
    })
}
